import type { Profile } from "@spork/s4p-server-sdk";

import type { StandardProfileFieldKey } from "../config/profileFormGroups";

/**
 * This function determines if a standard profile field is read-only based on the person's role.
 *
 * For custom fields, the object of custom field contains the can_edit flag, but
 * for standard fields, we need to determine if the field is read-only based on the person's role.
 * @param person
 * @param fieldKey
 * @returns
 */
export function isStandardFieldReadOnly(
    person: Profile,
    fieldKey: StandardProfileFieldKey
): boolean {
    if (person.role === "student") {
        return fieldKey === "first_name" || fieldKey === "last_name";
    }

    return false;
}
